/**
 * Format integer cents as USD (web-backend analytics use minor units for money).
 */
export function formatUsdFromCents(cents: number | undefined | null): string {
  if (cents == null || Number.isNaN(cents)) {
    return '—';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100);
}

export function formatUnixDate(sec: number | undefined | null): string {
  if (sec == null || Number.isNaN(sec)) {
    return '—';
  }
  return new Date(sec * 1000).toISOString().slice(0, 10);
}

export function formatPercent(value: number | undefined | null, fractionDigits = 1): string {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(fractionDigits)}%`;
}
